/**
 * Optional "By country" list ordering: country blocks A→Z, then column sort inside each block.
 */

import type { FC } from 'react';
import { Globe2 } from 'lucide-react';

import { Button } from '@/components/ui';
import { cn } from '@/lib/utils';

export interface CountryGroupSortToggleProps {
  active: boolean;
  onChange: (value: boolean) => void;
}

export const CountryGroupSortToggle: FC<CountryGroupSortToggleProps> = ({ active, onChange }) => (
  <Button
    type="button"
    variant={active ? 'secondary' : 'outline'}
    size="sm"
    className={cn('h-8 gap-1.5 px-2 text-xs', active && 'ring-1 ring-primary/30')}
    onClick={() => onChange(!active)}
    aria-pressed={active}
    aria-label={
      active
        ? 'Use one global sort order (turn off country blocks)'
        : 'Sort by country blocks, then by the active column within each country'
    }
  >
    <Globe2 className="h-3.5 w-3.5 shrink-0" aria-hidden />
    By country
  </Button>
);
